import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Shield } from "lucide-react";

export default function AdminLogin() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const user = await login(form.email, form.password);
      if (user.role !== "admin") {
        setError("This account does not have admin access.");
        return;
      }
      toast.success("Welcome, Admin");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 bg-[#07080C]">
      <div className="sadd-aurora" />
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="glass rounded-2xl p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="font-heading text-xl font-bold text-white">Admin Portal</h1>
              <p className="text-xs text-slate-400">Restricted access</p>
            </div>
          </div>
          {error && <div data-testid="admin-login-error" className="mb-4 text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-slate-300">Email</Label>
              <Input data-testid="admin-login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 bg-white/5 border-white/10 text-white" />
            </div>
            <div>
              <Label className="text-slate-300">Password</Label>
              <Input data-testid="admin-login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 bg-white/5 border-white/10 text-white" />
            </div>
            <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full glow-btn bg-gradient-to-r from-purple-600 to-blue-600 text-white border-0">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Secure Login"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
